import { Component, Output, EventEmitter, Inject } from '@angular/core';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import {
  FormsModule,
  FormGroup,
  UntypedFormGroup,
  UntypedFormBuilder,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule, DOCUMENT } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { LoginDialogComponent } from 'app/modules/dialogs/login-dialog/login-dialog.component';
import { DialogUtilsService } from 'app/modules/utils/dialog-utility.service';
import { FerrerAuthService } from 'app/services/authentication.service';
import { OtpDialogComponent } from 'app/modules/dialogs/otp-dialog/otp-dialog.component';
import { IframeSecurityService } from 'app/services/iframeSecurity.service';
import { ConsentDialogComponent } from 'app/modules/dialogs/consent-dialog/consent-dialog.component';
import { BlockedUserComponent } from '../blocked-user/blocked_user.component';
import { BlockedMedicalComponent } from '../non-medical/non_medical.component';
import { SessionService } from 'app/services/session.service';
import { DiffCountryDialogComponent } from 'app/modules/dialogs/diffcountry-dialog/diffcountry-dialog.component';
@Component({
  selector: 'user-exist',
  templateUrl: './user_exists.component.html',
  styleUrls: ['./user_exists.component.scss'],
  imports: [
    TranslocoPipe,
    FormsModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
    ReactiveFormsModule,
    CommonModule
  ],
})
export class UserExistComponent {
  @Output() next = new EventEmitter<void>();
  isLoading = false;
  loginSessionForm: FormGroup;
  emailApiError: string | null = null;
  passwordApiError: string | null = null;
  emailFromData: string = '';
  public titleParams = { suffix: '' }; // Initialize empty

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translocoService: TranslocoService,
    private _dialogRef: MatDialogRef<any>,
    private _formBuilder: UntypedFormBuilder,
    private _dialog: MatDialog,
    private dialogUtilsService: DialogUtilsService,
    private ferrerAuth: FerrerAuthService,
    private iframeSecurityService: IframeSecurityService,
    private sessionService: SessionService
  ) { }

  changeLang(lang: string) {
    this.translocoService.setActiveLang(lang);
  }
  ngOnInit(): void {
    this.emailFromData = this.data?.email || '';
    this.loginSessionForm = this._formBuilder.group({
      email: [this.emailFromData, Validators.required],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]],
    });
    this.titleParams = { suffix: '' };

    this.sessionService.digitalAsset$.subscribe(digitalAsset => {
      if (digitalAsset) {
        this.titleParams = { suffix: digitalAsset };
      }
    });
  }
  closeDialog(): void {
    this.dialogUtilsService.closeDialog(this._dialogRef);
  }
  openRegisterDialog(): void {
    if (this._dialogRef) {
      // Close without animation
      this._dialogRef.close();
    }

    const { width, height } = this.dialogUtilsService.calculateDialogSize();

    this._dialogRef = this._dialog.open(LoginDialogComponent, {
      width: `${width}px`,

      maxWidth: '90vw',
      maxHeight: '90vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      // Disable enter animation
      enterAnimationDuration: '0ms',
      // Disable exit animation
      exitAnimationDuration: '0ms'
    });

    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this._dialogRef);

    this._dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this._dialogRef = null;
    });
  }

  login(): void {
    if (!this.loginSessionForm) {
      return;
    }

    this.emailApiError = null;
    this.passwordApiError = null;

    const parentOrigin = this.iframeSecurityService.getParentOrigin();
    // Return if the form is invalid
    if (this.loginSessionForm.invalid) {
      this.loginSessionForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;


    const credentials = {
      email: this.loginSessionForm.get('email').value,
      password: this.loginSessionForm.get('password').value
    };
    this.ferrerAuth.login(credentials.email, credentials.password)
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          if (response && response.userAccess?.termsAccepted === false) {
            const currentCountry = JSON.parse(localStorage.getItem('currentCountryInfo'));
            if (response.userAccess?.country !== currentCountry.country) {
              this.opendiffCountryDialog(response);
            } else {
              this.openConsentsDialog(response);
            }

            return;
          }
          if (response && response.userAccess?.success === true) {
            // variara segun el contenido
            const isInIframe = this.isRunningInIframe();
            if (isInIframe) {
              // We're in an iframe, post message to parent
              if (window.parent && window.parent !== window) {
                window.parent.postMessage({
                  type: 'loginSuccess',
                  userData: {
                    email: this.loginSessionForm.get('email').value
                  }
                }, '*');
              }
            } else {
              // Not in an iframe, open in new tab
              this._dialogRef.close("response");

              // Navigate to the returnUrl in the same tab
              window.location.href = response.returnUrl;


            }

            // Close the dialog
            this._dialogRef.close("response");
          } else {
            this.isLoading = false;

            this.handleApiError(response);
          }
        },
        error: (err) => {
          this.isLoading = false;
          this.handleApiError(err);
        }
      });


  }
  openOtpDialog(): void {
    if (this._dialogRef) {
      this._dialogRef.close();
    }
    const email = this.loginSessionForm.get('email')?.value;

    this.ferrerAuth.sendOtpCode(email).subscribe({
      next: (response) => {

      },
      error: (error) => {
      }
    });

    const { width, height } = this.dialogUtilsService.calculateDialogSize();

    this._dialogRef = this._dialog.open(OtpDialogComponent, {
      width: `${width}px`,

      maxWidth: '90vw',
      //maxHeight: '90vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      data: {
        email: email,
      }
    });

    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this._dialogRef);

    this._dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this._dialogRef = null;
    });
  }
  getPasswordErrorMessage() {
    const passControl = this.loginSessionForm.get('password');
    if (passControl?.hasError('required')) return 'Introduce tu contraseña';
    if (passControl?.hasError('minlength')) {
      return 'La contraseña debe contener entre 6 y 16 caracteres';
    }
    if (passControl?.hasError('maxlength')) {
      return 'La contraseña debe contener entre 6 y 16 caracteres';
    }
    return '';
  }
  handleApiError(error: any): void {

    // Default error message
    let errorMessage = 'An unexpected error occurred';
    const errorCode = error.code || error.error.code || '';
    // Get error response body
    const errorBody = error.error.message || error.error || error;
    if (errorBody.includes('user has not accepted all consents') ||
      errorBody.includes('consents not accepted')) {
      this.openConsentsDialog();
      return;
    }
    if (errorBody.includes('Prohibido el acceso')) {
      this.openBlockedDialog();
      return;
    }

    if (errorBody.includes('LOGIN_REQUEST_WAS_NOT_VERIFIED_HCA') || errorBody.includes('LOGIN_REQUEST_HCA_RESULT_WAS_NO_MEDICAL_PROFESSIONAL') || errorCode.includes('LOGIN_REQUEST_HCA_RESULT_WAS_NO_MEDICAL_PROFESSIONAL')) {
      this.openBlockedHCADialog();
      return;
    }

    this.passwordApiError = errorBody;
    // Check for specific error types and map to form fields
    if (errorBody.code === 'AUTH_INVALID_CREDENTIALS' || errorBody.includes('No hay ning')) {
      // Invalid credentials - could be either email or password
      this.passwordApiError = errorBody;
    } else if (errorBody.code === 'AUTH_USER_NOT_FOUND' || errorBody.includes('user not found')) {
      // User not found - email issue
      this.passwordApiError = 'User not found';
    } else if (errorBody.code === 'AUTH_ACCOUNT_LOCKED' || errorBody.includes('locked')) {
      // Account locked
      this.passwordApiError = 'Account is locked. Please contact support.';
    } else if (errorBody.fieldErrors) {
      // Field-specific errors from API
      errorBody.fieldErrors.forEach(fieldError => {
        if (fieldError.field === 'email') {
          this.passwordApiError = fieldError.message;
        } else if (fieldError.field === 'password') {
          this.passwordApiError = fieldError.message;
        }
      });
    } else {
      // Generic error - show in both fields or use a general alert
      this.emailApiError = errorBody;
    }
  }

  private isRunningInIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch (e) {
      // If we get a security error, we're definitely in an iframe
      return true;
    }
  }
  openConsentsDialog(response?: any): void {
    if (this._dialogRef) {
      this._dialogRef.close();
    }
    const { width, height } = this.dialogUtilsService.calculateDialogSize();

    this._dialogRef = this._dialog.open(ConsentDialogComponent, {
      width: `${width}px`,
      //height: `${height-50}px`,
      maxWidth: '90vw',
      maxHeight: '85vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      data: {
        email: this.emailFromData,
        password: this.loginSessionForm.get('password').value,
        consentsAceptados: response.consents,
        userCountry: response.country || response.userAccess?.country
      }
    });

    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this._dialogRef);

    this._dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this._dialogRef = null;
    });
  }
  shouldShowCloseButton(): boolean {
    const apiVersion = JSON.parse(localStorage.getItem('ferrerSessionData'));
    return this.dialogUtilsService.shouldShowCloseButton();
  }
  opendiffCountryDialog(response: any): void {
    // Close any existing dialog
    if (this._dialogRef) {
      this._dialogRef.close();
    }

    const { width, height } = this.dialogUtilsService.calculateDialogSize();

    this._dialogRef = this._dialog.open(DiffCountryDialogComponent, {
      width: `${width}px`,
      //height: `${height}px`,
      maxWidth: '90vw',
      maxHeight: '65vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      data: {
        email: this.loginSessionForm.get('email')?.value,
        password: this.loginSessionForm.get('password').value,
        loginaction: "passwordLogin",
        consentsAceptados: response.consents
      }
    });

    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this._dialogRef);

    this._dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this._dialogRef = null;
    });
  }
  openBlockedDialog(): void {
    // Close any existing dialog
    if (this._dialogRef) {
      this._dialogRef.close();
    }

    const { width, height } = this.dialogUtilsService.calculateDialogSize();

    this._dialogRef = this._dialog.open(BlockedUserComponent, {
      width: `${width}px`,
      //height: `${height}px`,
      maxWidth: '90vw',
      maxHeight: '45vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      data: {
        email: this.emailFromData,
        password: this.loginSessionForm.get('password').value,
        loginaction: "passwordLogin"
      }
    });

    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this._dialogRef);

    this._dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this._dialogRef = null;
    });
  }

  openBlockedHCADialog(): void {
    // Close any existing dialog
    if (this._dialogRef) {
      this._dialogRef.close();
    }

    const { width, height } = this.dialogUtilsService.calculateDialogSize();

    this._dialogRef = this._dialog.open(BlockedMedicalComponent, {
      width: `${width}px`,
      //height: `${height}px`,
      maxWidth: '90vw',
      maxHeight: '55vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'custom-dialog-panel',
      data: {
        email: this.emailFromData,
        password: this.loginSessionForm.get('password').value,
      }
    });

    // Set up responsive behavior and get cleanup function
    const cleanupResizeListener = this.dialogUtilsService.setupResponsiveDialog(this._dialogRef);

    this._dialogRef.afterClosed().subscribe(() => {
      // Clean up the event listener
      cleanupResizeListener();
      this._dialogRef = null;
    });
  }
}